import React from "react"

import { Box } from "@mui/material"

import { t } from "@lingui/macro"

import {
    ErrorResponse,
    Loading,
    RestResponse,
} from "@sinossi/mates-react-library"

import withUseRouter, { UseRouterParams } from "services/router"
import {
    PageHeader,
    PageSectionTitle,
    RoutesData,
} from "components/commons"
import {
    MatesComponent,
    MatesComponentState,
} from "components/mates-component"
import {
    MicrojobberRequest,
    MicrojobberWrapper,
} from "models/microjobber"
import { PaginatedResponse } from "models"
import { MicrojobJobsTable } from "components/microjob/microjob-jobs-table/microjob-jobs-table"
import { MicrojobServices } from "services/microjob.services"
import MicrojobDetailModal from "components/microjob/microjob-detail-modal/microjob-detail-modal"
import { MicrojobAdvancedSearch } from "components/microjob/advanced-searchbar"

interface MicrojobJobsProps extends UseRouterParams {
}
interface MicrojobJobsState extends MatesComponentState {
    request: any
    loading: boolean
    microjobDetailModalOpen: boolean
    selectedMicrojob: any
    microjobs: PaginatedResponse<any> | null
}
class MicrojobJobs extends React.Component<MicrojobJobsProps, MicrojobJobsState> {
    private readonly matesComponent: MatesComponent<MicrojobJobsProps, MicrojobJobsState> = new MatesComponent(this)

    constructor(props: any) {
        super(props);
        this.state = {
            ...this.matesComponent.setupState(),
            request: MicrojobberRequest.empty(),
            loading: true,
            microjobDetailModalOpen: false,
            selectedMicrojob: null,
            microjobs: null,
        }
    }

    public componentDidMount() {
        this.filterMicrojobbers()
    }

    private filterMicrojobbers = (): void => {
        MicrojobServices.filterMicrojobs(
            this.state.request,
            this.getMicrojobbersCallback,
            this.matesComponent.onError
        )
    }

    private getMicrojobbersCallback = (response: RestResponse<PaginatedResponse<MicrojobberWrapper>, ErrorResponse>): void => {
        if (response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        this.setState(() => ({
            loading: false,
            microjobs: response.data,
        }))
    }

    private createMicrojobCallback = (response: RestResponse<PaginatedResponse<any>, ErrorResponse>): void => {
        if (response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        this.setState(() => ({
            loading: false,
        }))

        window.location.reload();
    }

    private handleTableCallback = (data: MicrojobberRequest) => {
        this.setState(
            () => ({
                loading: true,
                request: {
                    ...this.state.request,
                    ...data,
                },
            }),
            this.filterMicrojobbers
        )
    }

    private handleSearchbarCallback = (data: MicrojobberRequest) => {
        this.setState(
            () => ({
                loading: true,
                request: {
                    ...data,
                    orderBy: this.state.request.orderBy,
                    orderType: this.state.request.orderType,
                    pageSize: 10,
                    pageId: 0,
                },
            }),
            this.filterMicrojobbers
        )
    }

    private openMicrojobDetail = (microjob: any) => {

        this.setState(() => ({
            selectedMicrojob: microjob ?? null,
            microjobDetailModalOpen: true
        }))

    }


    private openMicrojobCreate = () => {

        this.setState(() => ({
            selectedMicrojob: null,
            microjobDetailModalOpen: true
        }))

    }

    private closeMicrojobDetail = () => {

        this.setState(() => ({
            microjobDetailModalOpen: false,
            selectedMicrojob: null
        }))

    }

    private microjobSubmitted = (data: any) => {

        this.setState(() => ({
            microjobDetailModalOpen: false,
            loading: true
        }))

        MicrojobServices.createMicrojob(
            data,
            this.createMicrojobCallback,
            this.matesComponent.onError
        )

    }

    private microjobConfirmed = (data: any) => {

        this.setState(() => ({
            microjobDetailModalOpen: false,
            loading: true
        }))

        MicrojobServices.confirmMicrojob(
            this.state.selectedMicrojob.id,
            this.createMicrojobCallback,
            this.matesComponent.onError
        )

    }

    render() {
        return (
            <Box sx={{ width: '100%', pt: 2, position: "relative" }}>
                <Loading show={this.state.loading} />
                {this.state.microjobDetailModalOpen && <MicrojobDetailModal
                    microjob={this.state.selectedMicrojob}
                    onClose={this.closeMicrojobDetail}
                    onMicrojobConfirm={this.microjobConfirmed}
                    submit={this.microjobSubmitted}
                    isAdmin
                />}
                <PageHeader
                    title={RoutesData.MICROJOB_JOBS.title}
                    paths={[RoutesData.DASHBOARD, RoutesData.MICROJOB_JOBS]}
                    addButtonModal={"Crea Microjob"}
                    onClickButtonModal={this.openMicrojobCreate}
                />

                <MicrojobAdvancedSearch handleCallback={this.handleSearchbarCallback} />
                <Box sx={{ mt: 3 }}>
                    <PageSectionTitle title={t({ id: "microjobs-title-table", message: "Microjobs" })} />
                    {
                        this.state.microjobs &&
                        <MicrojobJobsTable
                            data={this.state.microjobs}
                            handleCallback={this.handleTableCallback}
                            openModal={this.openMicrojobDetail} />
                    }
                </Box>
            </Box>
        )
    }
}

export default withUseRouter(MicrojobJobs)
